<template>
  <div class="policy-wrapper">
    <section id="privacy-policy">
      <h2>隐私政策</h2>
      <div class="legal-page">
        <p class="updated-at">最后更新日期：2025 年 1 月 1 日</p>

        <p>
          欢迎访问本网站。本隐私政策适用于由
          <strong>登竣实业（上海）有限公司</strong>
          （以下简称"我们"）运营的网站，以及网站提供的留言咨询、AI 交互服务。
          请您在使用本网站前仔细阅读并理解本政策内容。
        </p>

        <section>
          <h2>一、我们收集哪些信息</h2>

          <h3>1. 您主动提交的留言信息</h3>
          <p>
            当您在本网站填写留言、提交咨询时，我们可能会收集以下信息：
          </p>
          <ul>
            <li>您的姓名（如您填写）；</li>
            <li>您的联系方式（邮箱、电话等，如您填写）；</li>
            <li>您在留言中填写的咨询内容；</li>
            <li>提交时间及相关记录。</li>
          </ul>
          <p>上述信息仅用于与您取得联系并回复您的咨询。</p>

          <h3>2. AI 互动功能产生的信息</h3>
          <p>当您使用本网站的 AI 助手功能时，我们可能会收集：</p>
          <ul>
            <li>您向 AI 助手输入的文本内容；</li>
            <li>AI 助手生成的回复内容；</li>
            <li>会话时间、请求记录及相关日志信息。</li>
          </ul>
          <p>
            我们将上述信息用于为您提供 AI 咨询服务，并进行必要的服务安全审计与体验优化。
          </p>

          <h3>3. 网站运行过程中自动收集的信息</h3>
          <p>为保障网站的正常运行、安全和性能，我们可能自动收集：</p>
          <ul>
            <li>经匿名化处理的 IP 地址；</li>
            <li>浏览器类型、操作系统类型、访问设备类型；</li>
            <li>访问时间、停留时长、访问页面路径等；</li>
            <li>用于基础功能的 Cookie 信息。</li>
          </ul>
          <p>上述信息通常为统计类或技术类信息，无法单独识别您的个人身份。</p>
        </section>

        <section>
          <h2>二、我们如何使用您的信息</h2>
          <p>我们会将收集到的信息用于以下目的：</p>
          <ul>
            <li>回复您的留言和产品/服务相关咨询；</li>
            <li>为您提供 AI 咨询和互动服务；</li>
            <li>保障网站的正常运行和安全性；</li>
            <li>改进和优化网站功能与用户体验；</li>
            <li>根据相关法律法规的要求进行日志留存、安全审计等。</li>
          </ul>
          <p>
            我们不会将您的个人信息用于本政策未载明的其他用途，如需变更使用目的，我们将再次征求您的同意。
          </p>
        </section>

        <section>
          <h2>三、信息共享与第三方服务（DeepSeek API）</h2>
          <p>
            当您使用本网站的 AI 咨询功能时，您的部分信息会通过我们的服务器转发至 AI
            服务提供方，以便生成相应回答。
          </p>
          <p>当前我们使用的 AI 服务提供方为：<strong>DeepSeek API</strong>。</p>

          <h3>1. 可能共享的信息</h3>
          <p>在使用 AI 功能时，我们可能向 DeepSeek API 发送：</p>
          <ul>
            <li>您在对话框中输入的文本内容；</li>
            <li>请求标识符（如会话 ID 等匿名信息）。</li>
          </ul>
          <p>
            我们不会主动向 DeepSeek 传输您的手机号码、邮箱、身份证件号码等可直接识别您身份的信息。
          </p>

          <h3>2. 共享目的</h3>
          <p>上述信息仅用于：</p>
          <ul>
            <li>为您生成 AI 回答；</li>
            <li>保障服务的稳定性与安全性；</li>
            <li>必要的合规和风控处理。</li>
          </ul>

          <p>
            您在使用本网站的 AI 功能时，即视为您理解并同意上述信息处理方式。我们建议您避免在与
            AI 对话中输入任何敏感的个人信息。
          </p>
        </section>

        <section>
          <h2>四、信息保存期限</h2>
          <ul>
            <li>
              留言及联系方式等信息：通常保存
              <strong>12 个月</strong>，用于后续沟通与服务记录。
            </li>
            <li>
              AI 对话记录：通常保存
              <strong>6 个月</strong>，用于服务安全审计与体验优化。
            </li>
            <li>
              技术日志及安全日志：依照相关法律法规和业务需求保存，原则上仅保留必要期限。
            </li>
          </ul>
          <p>
            保存期限届满后，我们会对相关信息进行删除或匿名化处理，除非法律法规另有规定或为履行合约所必需。
          </p>
        </section>

        <section>
          <h2>五、您的权利</h2>
          <p>根据适用法律法规，您对您的相关信息享有以下权利：</p>
          <ul>
            <li>查询或访问我们是否持有您的相关信息；</li>
            <li>要求更正您认为不准确或不完整的信息；</li>
            <li>在符合法律规定条件下，要求删除您的个人信息；</li>
            <li>撤回对特定信息处理目的的同意；</li>
            <li>获取本隐私政策的最新版本。</li>
          </ul>
          <p>
            如您希望行使上述权利，您可通过本页面底部"联系方式"与我们取得联系。为保障安全，我们可能会先对您的身份进行合理核验。
          </p>
        </section>

        <section>
          <h2>六、信息安全措施</h2>
          <p>我们将采取合理可行的安全保护措施，防止信息遭到未授权访问、使用、披露、篡改或丢失，包括但不限于：</p>
          <ul>
            <li>通过 HTTPS 协议进行数据传输加密；</li>
            <li>访问权限控制和最小化授权原则；</li>
            <li>服务器防火墙与安全配置加固；</li>
            <li>必要的日志审计与安全监控。</li>
          </ul>
          <p>
            尽管我们已采取合理措施，但通过互联网进行信息传输无法保证百分之百安全。您理解并接受由此带来的客观风险。
          </p>
        </section>

        <section>
          <h2>七、Cookie 的使用</h2>
          <p>本网站可能使用少量必要型 Cookie，用于：</p>
          <ul>
            <li>保障网站页面与功能正常运行；</li>
            <li>维持基本会话状态（如留言表单、AI 会话状态）；</li>
            <li>进行匿名的访问统计与性能分析。</li>
          </ul>
          <p>
            我们不使用 Cookie 进行广告定向或跨站追踪。您可以通过浏览器设置管理或删除
            Cookie，但禁用必要 Cookie 可能影响部分功能使用。
          </p>
        </section>

        <section>
          <h2>八、AI 服务风险提示</h2>
          <p>
            本网站提供的 AI 助手服务基于 DeepSeek API 等技术实现，其回答由算法模型自动生成，可能存在不准确、不完整或不适用您具体场景的情况。
          </p>
          <p>因此：</p>
          <ul>
            <li>AI 内容仅供参考，不构成任何形式的专业建议；</li>
            <li>不应作为您做出重大决策的唯一依据；</li>
            <li>不代表登竣实业（上海）有限公司的立场或承诺。</li>
          </ul>
          <p>对于因您完全依赖 AI 内容所造成的直接或间接损失，我们在法律允许范围内不承担责任。</p>
        </section>

        <section>
          <h2>九、本政策的更新</h2>
          <p>
            随着业务发展或相关法律法规变化，我们可能适时对本隐私政策进行修订。更新后的政策将在本页面公布，并自公布之日起生效。
          </p>
        </section>

        <section>
          <h2>十、联系我们</h2>
          <p>如您对本隐私政策或个人信息处理相关事宜有任何疑问、意见或请求，您可以通过以下方式联系我们：</p>
          <p>
            登竣实业（上海）有限公司<br />
            邮箱：2302137948@qq.com<br />
            地址：上海市宝山区罗泾镇银石路288号
          </p>
        </section>
      </div>
    </section>
    <div class="divider"></div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyView',
  mounted() {
    console.log('隐私政策视图已挂载');
  }
}
</script>

<style scoped>
.policy-wrapper {
  width: 100%;
  padding-top: 0;
}

#privacy-policy {
  min-height: auto;
  padding: 20px 0 60px 0; /* 与其他页面保持一致的高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

#privacy-policy > h2 {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: white;
}

.legal-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px;
  line-height: 1.7;
  font-size: 14px;
  color: #f5f5f5;
  background: #222;
  border-radius: 10px;
  text-align: left;
  width: 80%;
}

.legal-page h1 {
  font-size: 24px;
  margin-bottom: 8px;
  color: white;
}

.legal-page .updated-at {
  font-size: 13px;
  color: #999;
  margin-bottom: 20px;
}

.legal-page section {
  margin-bottom: 30px;
}

.legal-page h2 {
  font-size: 18px;
  margin-top: 24px;
  margin-bottom: 12px;
  color: white;
  border-bottom: 2px solid #e50914;
  padding-bottom: 8px;
}

.legal-page h3 {
  font-size: 15px;
  margin-top: 16px;
  margin-bottom: 8px;
  color: #e50914;
  font-weight: 600;
}

.legal-page p {
  margin: 12px 0;
  line-height: 1.8;
}

.legal-page strong {
  color: #e50914;
  font-weight: 600;
}

.legal-page ul {
  padding-left: 24px;
  margin: 8px 0 16px;
}

.legal-page li {
  margin: 6px 0;
  line-height: 1.7;
}

.divider {
  width: 80%;
  max-width: 1200px;
  height: 2px;
  background: #e50914;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .legal-page {
    width: 90%;
    padding: 24px 16px;
    font-size: 13px;
  }

  .legal-page h2 {
    font-size: 16px;
  }

  .legal-page h3 {
    font-size: 14px;
  }
}
</style>

